import ReactModal from 'react-modal'
import classes from './GuideModal.module.scss'
import type { ReactNode } from 'react'

type from = 'bottom' | 'right'

// Transition and position styling to apply to the modal when it is opened/closed
const overlayClasses: Record<from, string> = {
  bottom: classes.GuideModalContentFromBottom,
  right: classes.GuideModalContentFromRight
}

export interface Props {
  children: ReactNode
  closeTimeoutMS?: number
  isOpen?: boolean
  label: string
  onRequestClose: () => void
  from: from
}

const GuideModal = ({
  children,
  closeTimeoutMS = 500,
  isOpen = false,
  label,
  onRequestClose,
  from
}: Props) =>
  <ReactModal
    ariaHideApp={false} // this should be revisited if Modals always use the same title element
    className={classes.GuideModal}
    closeTimeoutMS={closeTimeoutMS} // allow for exit animation
    contentLabel={label}
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    overlayClassName={`${classes.GuideModalOverlay} ${overlayClasses[from]}`}
    shouldCloseOnEsc={false}
    shouldCloseOnOverlayClick={false}
  >
    {children}
  </ReactModal>

export default GuideModal
